import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "action-bar" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = {
  key: 0,
  class: "mt20 summary-title",
  style: {"color":"#F56C6C","font-weight":"bold","font-size":"18px","display":"flex"}
}
const _hoisted_6 = { style: {"margin-right":"30px"} }
const _hoisted_7 = { style: {"margin-right":"30px"} }
const _hoisted_8 = { style: {"margin-right":"30px"} }
const _hoisted_9 = { style: {"margin-right":"30px"} }
const _hoisted_10 = {
  key: 1,
  class: "summary-box"
}
const _hoisted_11 = { class: "summary-list" }
const _hoisted_12 = { class: "summary-item" }
const _hoisted_13 = { class: "txt" }
const _hoisted_14 = { class: "summary-item" }
const _hoisted_15 = { class: "txt" }
const _hoisted_16 = { class: "summary-item" }
const _hoisted_17 = { class: "txt" }
const _hoisted_18 = { class: "summary-item" }
const _hoisted_19 = { class: "txt" }
const _hoisted_20 = { class: "summary-item" }
const _hoisted_21 = { class: "txt" }
const _hoisted_22 = { class: "summary-item" }
const _hoisted_23 = { class: "txt" }
const _hoisted_24 = { class: "card-header" }
const _hoisted_25 = { class: "tips" }
const _hoisted_26 = { class: "card-header" }
const _hoisted_27 = { class: "tips" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "color-info" }
const _hoisted_30 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onRedirect('/partner/order-list')))
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("订单列表")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRedirect('/partner/prevpay-list')))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("预付款明细")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.userType==1)
          ? (_openBlock(), _createBlock(_component_el_select, {
              key: 0,
              modelValue: _ctx.channel_no,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.channel_no) = $event)),
              placeholder: "请选择查询渠道",
              filterable: "",
              style: {"width":"150px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.channel_name,
                    value: item.channel_no
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.start_time,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.start_time) = $event)),
            placeholder: "开始日期",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue"]),
          _cache[11] || (_cache[11] = _createTextVNode(" - ")),
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.end_time,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.end_time) = $event)),
            placeholder: "结束日期",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.getSummary
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("查询")
          ])),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.userType==3)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSettleExport()))
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("结算订单导出")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.summary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, " 预付款：" + _toDisplayString(_ctx.cF(_ctx.summary.channel_remain_money)), 1),
          _createElementVNode("div", _hoisted_7, " 可用预付款：" + _toDisplayString(_ctx.cF(_ctx.summary.use_remain_money)), 1),
          _createElementVNode("div", _hoisted_8, " 平台使用费：" + _toDisplayString(_ctx.cF(_ctx.summary.technical_fee)), 1),
          _createElementVNode("div", _hoisted_9, " 风控额度：" + _toDisplayString(_ctx.cF(_ctx.summary.deposit)), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider),
    (_ctx.summary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "label" }, "已支付订单", -1)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.summary.pay_succeed_count), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "label" }, "已取消订单", -1)),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.summary.pay_cancel_count), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "label" }, "已退款订单", -1)),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.summary.pay_refund_count), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "label" }, "消费金额", -1)),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.cF(_ctx.summary.consume_money)), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[18] || (_cache[18] = _createElementVNode("p", { class: "label" }, "实付金额", -1)),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.cF(_ctx.summary.money_sum)), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[19] || (_cache[19] = _createElementVNode("p", { class: "label" }, "退款金额", -1)),
              _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.cF(_ctx.summary.refund_money)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, { class: "box-card test-card" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _cache[20] || (_cache[20] = _createElementVNode("span", null, "测试环境配置", -1)),
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.channelConfig.test.tips), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createTextVNode("域名：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.test.domain), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode("渠道号：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.test.channel_no), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("渠道名称：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.test.channel_name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("密钥：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.test.apikey || '--'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [
                _createTextVNode("余额：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.test.money), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { class: "box-card formal-card" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _cache[26] || (_cache[26] = _createElementVNode("span", null, "生产环境配置", -1)),
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.channelConfig.formal.tips), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[27] || (_cache[27] = [
                _createTextVNode("域名：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.formal.domain), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [
                _createTextVNode("渠道号：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.formal.channel_no), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[29] || (_cache[29] = [
                _createTextVNode("渠道名称：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.formal.channel_name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => _cache[30] || (_cache[30] = [
                _createTextVNode("密钥：")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 17 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.channelConfig.formal.apikey || '--'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "btn-mini",
                  type: "info",
                  plain: "",
                  size: "small",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogVisible=true))
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("查看")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "查看密钥",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "before-close": _ctx.beforeDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: _ctx.beforeDialogClose }, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.secret)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("p", _hoisted_29, "密钥：" + _toDisplayString(_ctx.secret), 1),
              _cache[32] || (_cache[32] = _createElementVNode("p", { class: "color-danger mt15 font12" }, "* 此密钥仅在此处以明文展示，请妥善保存", -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createTextVNode("已绑定手机号： " + _toDisplayString(_ctx.channelConfig.formal.phone) + " ，", 1),
                  _createVNode(_component_el_link, {
                    type: "primary",
                    href: "javascript:;",
                    disabled: _ctx.second > 0,
                    onClick: _ctx.onSendCode
                  }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode("发送验证码")
                    ])),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.code,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.code) = $event)),
                    placeholder: "输入验证码",
                    style: {"width":"200px","margin-right":"10px"}
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createVNode(_component_el_button, {
                    type: "info",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.second), 1)
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.second > 0]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.onGetSecret,
                disabled: _ctx.code.length===0
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [
                  _createTextVNode("查看")
                ])),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}